import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { Fhe, Airzone, Zwave } from '.';

class Product extends PureComponent {
    static propTypes = {
        productType: PropTypes.string.isRequired
    };

    render() {
        const { productType } = this.props;

        const detailContentByType = {
            airzone: () => <Airzone {...this.props} />,
            zwave: () => <Zwave {...this.props} />,
            fhe_product: () => <Fhe {...this.props} />
        };
        return detailContentByType[productType]();
    }
}

export default withRouter(renderEnvComponent('scenes/Products/components/Product/ProductDtail', Product));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/ProductDetail.js